import * as React from 'react';
const SvgLocation = (props) => (
  <svg
    width={15}
    height={17}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity={0.4}
      d="M14.4 7.61111C14.4 11.5385 9.9 16.5 7.2 16.5C4.5 16.5 0 11.5385 0 7.61111C0 3.68375 3.22355 0.5 7.2 0.5C11.1764 0.5 14.4 3.68375 14.4 7.61111Z"
      fill="#605AFB"
    />
    <path
      d="M9.5998 7.6998C9.5998 9.02529 8.52529 10.0998 7.1998 10.0998C5.87432 10.0998 4.7998 9.02529 4.7998 7.6998C4.7998 6.37432 5.87432 5.2998 7.1998 5.2998C8.52529 5.2998 9.5998 6.37432 9.5998 7.6998Z"
      fill="#605AFB"
    />
  </svg>
);
export default SvgLocation;
